import React from "react";
import "./Style.css";
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'


const FormStepProgress = ({ totalStep, currentStep, setCurrentStep,stepTab }) => {

    const gotoStep = (e, stepNumber) => {
        e.preventDefault()
        setCurrentStep(stepNumber)
    }
    return (
        <div className="form-step-progress">
            {Array.from({ length: totalStep }).map((_, index) => {
                const stepNumber = index + 1;
                const isCompleted = stepNumber < currentStep;
                const isActive = stepNumber === currentStep;

                return (
                    <div className="step-wrapper" key={index}>
                        {/* Circle */}
                        <div
                            className={`step-circle ${isCompleted ? "completed" : isActive ? "active" : ""
                                }`}
                            onClick={(e) => gotoStep(e, stepNumber)}
                            style={{ cursor: "pointer" }}
                            // title={`${stepTitle[stepNumber-1]}`}
                            data-tooltip-id={`tooltip-${stepNumber}`}
                            data-tooltip-content={`${stepTab[stepNumber-1]}`}
                        >
                            {stepNumber}
                        </div>
                        <Tooltip id={`tooltip-${stepNumber}`} place="top" />

                        {/* Bar */}
                        {stepNumber !== totalStep && (
                            <div
                                className={`step-bar ${isCompleted ? "completed" : ""
                                    }`}
                            ></div>
                        )}
                    </div>
                );
            })}
        </div>
        
    );
};

export default FormStepProgress;
